import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, map } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CloudinarySignatureRequest {
  folder: string;
  upload_preset: string;
  unique_filename: boolean;
  use_filename: boolean;
  timestamp: number;
}

@Injectable({ providedIn: 'root' })
export class CloudinaryUploadService {

  loadingState$: BehaviorSubject<any> = new BehaviorSubject<any>(0);

  constructor(private httpClient: HttpClient) {}
  
  generateCloudinaryToken(folder, isUseFileName = 'false', resourceType = 'image') {
    let params = new HttpParams();
    params = params.set('folder', folder);
    params = params.set('presetName', 'my_preset');
    params = params.set('timeStamp', Math.round((new Date()).getTime() / 1000).toString());
    params = params.set('isFileNameUnique', 'false');
    params = params.set('isUseFileName', isUseFileName);
    params = params.set('resourceType', resourceType);
    return this.httpClient.get(`${environment.baseDomain}/cloud/file/token`, { params }).pipe(map((res: any) => res.data));
  }

  replaceCurrent(publicId, resourceType) {
    let params = new HttpParams();
    params = params.set('publicId', publicId);
    params = params.set('resourceType', resourceType);
    return this.httpClient.delete(`${environment.baseDomain}/cloud/file`, { params }).subscribe();
  }

  uploadFile(file, folder, removePublicId = null, isUseFileName = 'false') {
    return new Promise(async resolve => {
      const resourceType = file && (file.type.includes('image/') || file.type.includes('/pdf')) ? 'image' : 'raw';
      if (removePublicId) {
        this.replaceCurrent(removePublicId, resourceType);
      }
      const uploadUrl = `${environment.cloudinaryApiUrl}/upload`;
      const params = {
        folder: `${environment.cloudinaryContentFolder}/${folder}`,
        upload_preset: environment.cloudinaryUploadPreset,
        timestamp: Math.round((new Date()).getTime() / 1000),
        unique_filename: 'false',
        use_filename: isUseFileName,
        resource_type: resourceType
      };
      const signature = await this.generateCloudinaryToken(params.folder, isUseFileName, resourceType).toPromise();
      const xhr = new XMLHttpRequest();
      const formData = new FormData();
      xhr.open('POST', uploadUrl, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      let prevUploadVal = 0;
      xhr.upload.onprogress = (e) => {
        const currStateVal = this.loadingState$.getValue();
        const currVal = Math.ceil(e.loaded / e.total * 100);
        const valueToSet = Math.ceil(currStateVal + (currVal - prevUploadVal));
        prevUploadVal = currVal;
        if (valueToSet <= 100) {
          this.loadingState$.next(valueToSet);
        }
      }
      xhr.onreadystatechange = (e) => {
        if (xhr.responseText) {
          const response = JSON.parse(xhr.responseText);
          if (xhr.readyState === 4 && response.error) {
            resolve(null);
            this.clearLoading();
          }
          if (xhr.readyState === 4 && xhr.status === 200) {
            resolve(response.public_id);
            this.clearLoading();
          }
        }
      };
      for (const [key, value] of Object.entries(params)) {
        formData.append(key, value as string);
      }
      formData.append('signature', signature);
      formData.append('api_key', environment.cloudinaryApiKey);
      formData.append('file', file);
      xhr.send(formData);
    });
  }

  startLoading() {
    this.loadingState$.subscribe(length => console.log('progress', length))
  }

  clearLoading() {
    this.loadingState$.next(0);
  }

}
